import { useEffect, useState } from "react";
import { Sparkles } from "lucide-react";

const LINKS = [
  ["Ventures", "#ventures"],
  ["Experience", "#experience"],
  ["Research", "#research"],
  ["Audience", "#social"],
  ["Engage", "#engage"],
];

export const scrollToId = (id) => {
  const el = document.querySelector(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -72, duration: 1.2 });
  else el.scrollIntoView({ behavior: "smooth" });
};

export const openAIChat = () => window.dispatchEvent(new CustomEvent("open-ai-chat"));

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const fn = () => setScrolled(window.scrollY > 24);
    fn();
    window.addEventListener("scroll", fn, { passive: true });
    return () => window.removeEventListener("scroll", fn);
  }, []);

  return (
    <header
      data-testid="nav-bar"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled ? "glass border-x-0 border-t-0" : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12 h-16 sm:h-20 flex items-center justify-between">
        <button
          data-testid="nav-logo-button"
          onClick={() => scrollToId("#home")}
          className="flex items-center gap-3 group"
        >
          <span className="grid place-items-center w-9 h-9 rounded-lg border border-white/10 bg-panel overflow-hidden">
            <img src="/images/headshot.png" alt="" className="w-full h-full object-cover opacity-90 group-hover:scale-110 transition duration-500" />
          </span>
          <span className="font-display font-semibold tracking-tight text-sm sm:text-base text-left">
            Dr. Rahul Kanungo<span className="text-neon">.</span>
            <span className="block text-[10px] font-mono font-normal text-slate-500 tracking-[0.18em] uppercase">
              Medicine × AI
            </span>
          </span>
        </button>

        <nav className="hidden md:flex items-center gap-8">
          {LINKS.map(([label, href]) => (
            <button
              key={href}
              data-testid={`nav-link-${label.toLowerCase()}`}
              onClick={() => scrollToId(href)}
              className="text-sm text-slate-400 hover:text-white transition-colors duration-300"
            >
              {label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <span className="hidden lg:flex items-center gap-2 text-xs font-mono text-emerald-400/90 border border-emerald-400/20 rounded-full px-3 py-1.5">
            <span className="relative flex h-1.5 w-1.5">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-60" />
              <span className="relative inline-flex rounded-full h-1.5 w-1.5 bg-emerald-400" />
            </span>
            Open to opportunities
          </span>
          <button
            data-testid="nav-ask-ai-button"
            onClick={openAIChat}
            className="group flex items-center gap-2 rounded-full px-4 py-2 text-sm font-semibold text-ink bg-gradient-to-r from-neon to-vio hover:shadow-glow-cyan transition-shadow duration-300"
          >
            <Sparkles size={14} className="group-hover:rotate-12 transition-transform duration-300" />
            Ask my AI
          </button>
        </div>
      </div>
    </header>
  );
}